import gql from 'graphql-tag';

const GET_SUBMISSION_STATUS_BY_CASE = gql`
  query getSubmissionStatusByCase($caseExternalId: String!) {
    getSubmissionStatusByCase(caseExternalId: $caseExternalId) {
      submissionId
      caseExternalId
      status
      caseStatus
      attemptCount
      deadLettered
      errorCode
      errorMessage
      processedAt
      createdAt
      updatedAt
    }
  }
`;

export default GET_SUBMISSION_STATUS_BY_CASE;
